import { inject, Injectable } from '@angular/core';
import { angularjs } from '@app/service/migration-helpers/angularjs.injection';
import type { EmailValidationService } from '@app/interface/service/email-validation-service.interface';
import type { ValidationService } from '@app/interface/service/validation-service.interface';

/** Validates an Apple Pay email using the application's local and server-side checks. */
@Injectable()
export class ApplePayEmailValidationService {
  private readonly validationService: ValidationService = inject(angularjs.ValidationService);
  private readonly emailValidationService: EmailValidationService = inject(angularjs.EmailValidationService);

  async isValid(email: string | undefined): Promise<boolean> {
    if (!this.validationService.isValidEmailFormat(email)) {
      return false;
    }

    try {
      const result = await this.emailValidationService.validateEmail(email);
      return Boolean(result && result.success);
    } catch {
      return false;
    }
  }
}
